import React from 'react';
import { Box, Typography } from '@mui/material';

import CheckoutSectionHeading from './checkout/CheckoutSectionHeading';
import CheckoutSelectionCard from './checkout/CheckoutSelectionCard';
import { V2_PAYMENT_TYPE } from '../services/checkout';

const OPTIONS = [
  { value: V2_PAYMENT_TYPE.ONLINE, label: 'Online · UPI' },
  { value: V2_PAYMENT_TYPE.COD, label: 'Cash on delivery' },
];

/**
 * Checkout payment method (V2): COD or online (Cashfree on the next step).
 * @param {{ value: string, onChange: (value: string) => void }} props
 */
export default function CheckoutPaymentSelect({ value, onChange }) {
  return (
    <Box sx={{ mt: 3 }}>
      <CheckoutSectionHeading sx={{ mb: 1.5 }}>Payment method</CheckoutSectionHeading>
      <Box sx={{ display: 'flex', gap: 1.25 }}>
        {OPTIONS.map((opt) => {
          const selected = value === opt.value;
          return (
            <CheckoutSelectionCard
              key={opt.value}
              selected={selected}
              onClick={() => onChange(opt.value)}
              sx={{
                flex: 1,
                alignItems: 'center',
                py: 1.75,
                px: 1.25,
              }}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{ color: 'inherit', lineHeight: 1.3 }}
              >
                {opt.label}
              </Typography>
            </CheckoutSelectionCard>
          );
        })}
      </Box>
    </Box>
  );
}
